import { Component, ElementRef, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { distinctUntilChanged, fromEvent, map, Subscription } from 'rxjs';
import { materialSymbols } from '../../../shared/constants/material-symbols';

@Component({
    selector: 'app-back-to-top',
    templateUrl: './back-to-top.component.html',
    styleUrl: './back-to-top.component.scss',
    standalone: false
})
export class BackToTopComponent implements OnInit, OnDestroy {
  @ViewChild('pageBottomButton') pageBottomButton!: ElementRef;
  @Input() id: string = 'btn-back-to-top';
  isFloatingButtonVisible: boolean = false;

  arrowUpward = materialSymbols.arrowUpward;
  subscriptions: Subscription = new Subscription();

  ngOnInit(): void {

    const windowScrollSubscription = fromEvent(window, 'scroll')
      .pipe(
        //Check whether page has moved away from top or bottom
        map((e: Event) : PagePosition => {
          const isNearBottomOfPage = this.isNearBottomOfPage();
          const isNearTopOfPage = this.isNearTopOfPage();
          return { isNearBottomOfPage, isNearTopOfPage };
        }),
        // Only emit when the above condition changes
        distinctUntilChanged((prev, curr) => {
          return prev.isNearBottomOfPage === curr.isNearBottomOfPage && prev.isNearTopOfPage === curr.isNearTopOfPage;
        })
      )
      .subscribe((pagePosition: PagePosition) => {
        this.setFloatingButtonVisibility(pagePosition);
      });

    this.subscriptions.add(windowScrollSubscription);
  }

  ngOnDestroy(): void {
    if (this.subscriptions) {
      this.subscriptions.unsubscribe();
    }
  }

  setFloatingButtonVisibility(pagePosition: PagePosition): void {
    this.isFloatingButtonVisible = !pagePosition.isNearBottomOfPage && !pagePosition.isNearTopOfPage;
  }

  isNearTopOfPage(): boolean {
    const result = document.body.scrollTop <= 20 && document.documentElement.scrollTop <= 20;
    return result;
  }

  isNearBottomOfPage(): boolean {
    const pageBottomButtonElement = this.pageBottomButton.nativeElement;

    const result = pageBottomButtonElement.getBoundingClientRect().top < window.innerHeight;
    return result;
  }

  scrollToTop(): void {
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
  }
}

interface PagePosition {
  isNearBottomOfPage: boolean;
  isNearTopOfPage: boolean;
}
